module.exports = __webpack_public_path__ + "img/2.1.58a57e18.png";